import React from 'react';
import { Text } from '@chakra-ui/react';
import { Condition } from './index';

export const ConditionA = React.memo(() => {
  return (
    <Condition>
      <Text
        fontWeight="bold"
        fontSize={{ base: 18, sm: 20, md: 18, lg: 20 }}
        color="pink.500"
        lineHeight={1.2}
      >
        消費滿$
        <Text
          as="span"
          fontSize={{ base: 30, sm: 40, md: 30, lg: 40 }}
          display="inline"
        >
          200
        </Text>
      </Text>
      <Text color="gray.700" fontSize={{ base: 11, sm: 13, md: 14, lg: 16 }}>
        (單一交易以折後價計算)
      </Text>
    </Condition>
  );
});
